import React, { useEffect } from "react";
import classnames from "classnames";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import _ from "lodash";

import {
  getIsConfigReady,
  fetchConfig,
  getConfigThemeColor,
  setMediaSize,
} from "../../store/configSlice";
import { getIsFetchError } from "../../store/transportSlice";
import { Header } from "../Header/Header";
import { MapPrepare } from "../Map/MapPrepare";
import { HideTrack } from "../HideTrack/HideTrack";

import useMediaQuery, {
  MEDIA_QUERIES,
  MEDIA_SIZES,
} from "../../util/useMediaQuery";

import styles from "./App.module.scss";
import errorImg from "./error.svg";

function AppBody({
  isReady,
  isFetchError,
  fetchConfig,
  themeColor,
  setMediaSize,
}) {
  const size = useMediaQuery(
    MEDIA_QUERIES.queryList,
    MEDIA_QUERIES.defaultValue
  );

  useEffect(() => {
    setMediaSize(size);
  }, [size]);

  useEffect(() => {
    fetchConfig();
  }, [fetchConfig]);

  useEffect(() => {
    if (!_.isEmpty(themeColor)) {
      document
        .querySelector("meta[name=theme-color]")
        .setAttribute("content", themeColor);
    }
  }, [themeColor]);

  if (!isReady) {
    return <div className={styles.pending} />;
  }

  return (
    <>
      <Header />
      <MapPrepare />
      <HideTrack />

      <div
        className={classnames(styles.errorWrapper, {
          [styles.errorWrapperShown]: isFetchError,
        })}
      >
        <img src={errorImg} alt="error" />
        <div className={styles.errorText}>Сервер не отвечает</div>
      </div>
    </>
  );
}

AppBody.propTypes = {
  isReady: PropTypes.bool.isRequired,
  isFetchError: PropTypes.bool.isRequired,
  fetchConfig: PropTypes.func.isRequired,
};

const App = connect(
  (state) => ({
    isReady: getIsConfigReady(state),
    isFetchError: getIsFetchError(state),
    themeColor: getConfigThemeColor(state),
  }),
  {
    fetchConfig,
    setMediaSize,
  }
)(AppBody);

App.propTypes = {};

export { App };
